<div class="contents" [attr.aria-busy]="loading">
  <app-back-button></app-back-button>

  <div class="page-header">
    <div class="left-area">
      <span class="title">Período de Renovação de Matrícula</span>
      <span class="sub-title">Configure os períodos de renovação de matrícula dos bolseiros</span>
    </div>

  </div>

  <div class="page-actions">
    <p-button label="Filtros" icon="pi pi-filter" (onClick)="showFilterDrawer = true"></p-button>
    <div *appHasAnyRole="permissoes">
      <p-button label="Novo Período" icon="pi pi-plus-circle" (onClick)="openNovoPeriodo()"></p-button>
    </div>
  </div>

  <ng-container *ngIf="periodos.length || loading; else vazio">
    <p-table
      [value]="periodos"
      [loading]="loading"
      [lazy]="true"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 20, 50]"
      (onLazyLoad)="onPageChange($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Ano Lectivo</th>
          <th>Tipo de Bolsa</th>
          <th>Data Início</th>
          <th>Data Fim</th>
          <th *ngIf="hasActivoColumn">Estado</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-periodo>
        <tr>
          <td>{{ periodo.anoLectivo || anoLectivoLabel(periodo.anoLectivoId) }}</td>
          <td>{{ tipoBolsaLabel(periodo) }}</td>
          <td>{{ toDisplayDate(periodo.dataInicio) }}</td>
          <td>{{ toDisplayDate(periodo.dataFim) }}</td>
          <td *ngIf="hasActivoColumn">
            <p-tag [severity]="periodo.activo ? 'success' : 'danger'" [value]="periodo.activo ? 'Activo' : 'Inactivo'"></p-tag>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <ng-template #vazio>
    <app-data-void
      titulo="Nenhum período de renovação encontrado"
      descricao="Clique em Novo Período para criar o primeiro."
    ></app-data-void>
  </ng-template>

  <app-periodo-renovacao-drawer
    *ngIf="showDrawer"
    (closed)="onDrawerClosed($event)"
  ></app-periodo-renovacao-drawer>

  <p-drawer
    header="Filtros"
    [(visible)]="showFilterDrawer"
    position="right"
    [style]="{ width: '680px', maxWidth: '100vw' }"
    styleClass="periodo-filter-drawer"
  >
    <form [formGroup]="filterForm" class="filter-drawer-form" (ngSubmit)="applyFilters()">
      <div class="filter-drawer-intro">
        <span class="intro-title">Filtrar períodos</span>
        <span class="intro-description">Refine os resultados por ano lectivo, tipo de bolsa ou intervalo de datas.</span>
      </div>

      <div class="filter-field field-full">
        <label for="anoLectivoFilter">Ano Lectivo</label>
        <p-calendar
          inputId="anoLectivoFilter"
          class="w-full"
          formControlName="anoLectivo"
          view="year"
          dateFormat="yy"
          placeholder="Selecione o ano"
          [showIcon]="true"
          [showClear]="true"
          [minDate]="minAnoLectivoDate"
          [maxDate]="maxAnoLectivoDate"
          appendTo="body"
        ></p-calendar>
        <small class="field-hint">Selecione diretamente o ano no calendário.</small>
      </div>

      <div class="filter-field field-full">
        <label for="tipoBolsaFilter">Tipo de Bolsa</label>
        <p-select
          inputId="tipoBolsaFilter"
          class="w-full"
          [options]="tipoBolsaOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="tipoBolsaEnum"
          placeholder="Todos"
          [showClear]="true"
          appendTo="body"
        ></p-select>
      </div>

      <div class="filter-date-fields">
        <div class="filter-field">
          <label for="dataInicioFilter">Data Início</label>
          <p-calendar
            inputId="dataInicioFilter"
            class="w-full"
            formControlName="dataInicio"
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/aaaa"
            [showIcon]="true"
            [showClear]="true"
            [maxDate]="filterForm.get('dataFim')?.value"
            appendTo="body"
          ></p-calendar>
        </div>

        <div class="filter-field">
          <label for="dataFimFilter">Data Fim</label>
          <p-calendar
            inputId="dataFimFilter"
            class="w-full"
            formControlName="dataFim"
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/aaaa"
            [showIcon]="true"
            [showClear]="true"
            [minDate]="filterForm.get('dataInicio')?.value"
            appendTo="body"
          ></p-calendar>
        </div>
      </div>

      <div class="filter-drawer-actions">
        <p-button type="button" label="Limpar filtros" severity="secondary" [outlined]="true" (onClick)="clearFilters()"></p-button>
        <p-button type="submit" label="Filtrar" icon="pi pi-search"></p-button>
      </div>
    </form>
  </p-drawer>
</div>

<p-toast></p-toast>
